import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CircleDollarSign, ChevronRight } from 'lucide-react';
import { goAdmin } from '../../lib/adminLinks';
import { HelpLink } from './HelpLink';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Dashboard card: configurator-created quotes still needing pricing; click opens Sales → Quotes filtered.
export const NeedsPricingCard = ({ token }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    axios.get(`${API_URL}/admin/needs-pricing-summary`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setD(r.data)).catch(() => setD(null));
  }, [token]);
  if (!d) return null;
  return (
    <div className="rounded-xl border border-neutral-200 bg-white px-4 py-3 flex items-center justify-between gap-4" data-testid="dashboard-needs-pricing">
      <button type="button" onClick={() => goAdmin('quotes', { filter: 'needs_pricing' })} className="group flex flex-1 items-center gap-4 text-left" data-testid="dashboard-needs-pricing-open">
        <span className="w-9 h-9 rounded-lg bg-orange-100 text-orange-700 flex items-center justify-center"><CircleDollarSign className="w-4 h-4" /></span>
        <span className="flex flex-wrap items-baseline gap-x-6 gap-y-1">
          <span className="text-sm text-neutral-700">Needs Pricing: <strong className="text-lg text-neutral-900" data-testid="dashboard-needs-pricing-count">{d.count}</strong></span>
          <span className="text-sm text-neutral-700">Overdue (over 3 days): <strong className={`text-lg ${d.overdue ? 'text-red-700' : 'text-neutral-400'}`} data-testid="dashboard-needs-pricing-overdue">{d.overdue}</strong></span>
        </span>
        <ChevronRight className="w-4 h-4 text-neutral-400 ml-auto group-hover:translate-x-0.5 transition-transform" />
      </button>
      <HelpLink topic="needs-pricing" testId="dashboard-needs-pricing-help" />
    </div>
  );
};
